import * as _ from "lodash";
import * as angular from "angular";
import { CanvassStatus } from "../../models/canvass-status.model";
import { DialogUtils } from "../../helper/dialog.helper";
import { CanvassStatusDataProvider } from "../../data-provider/canvass-status.dp";

let DeleteCanvassStatus = {
    selector: "vcDeleteCanvassStatus",
    templateUrl:
        "/angular/components/canvass-status/delete-canvass-status.component.html",
    bindings: {
        selectedStatus: "=?",
    },
    controller: class DeleteCanvassStatusController {
        // * bindings for typescript compiler *
        public selectedStatus?: any;
        // ************************************

        private dataProvider: CanvassStatusDataProvider;
        private dialog: DialogUtils;

        public saving: boolean;
        public status: CanvassStatus;

        constructor(
            DialogUtils: DialogUtils,
            CanvassStatusDataProvider: CanvassStatusDataProvider
        ) {
            this.dataProvider = CanvassStatusDataProvider;
            this.dialog = DialogUtils;
        }

        $onInit() {
            this.status = _.cloneDeep(this.selectedStatus);
        }

        deleteStatus(status: CanvassStatus): void {
            this.saving = true;
            this.dataProvider.delete(status).then(
                (status) => this.dialog.hide(status),
                (error) => console.log(error)
            );
        }

        ok(): void {
            this.deleteStatus(this.status);
        }

        cancel(): void {
            this.dialog.hide();
        }
    },
};

angular
    .module("canvassStatus")
    .component(DeleteCanvassStatus.selector, DeleteCanvassStatus);
